const sync_statuses = {
    ERR: {
        name: 'ERR',
        color: 'error',
        icon: 'mdi-alert',
        text: 'Возникла ошибка'
    },
    WAIT: {
        name: 'WAIT',
        color: 'secondary',
        icon: 'mdi-sync',
        text: 'Синхронизация данных'
    },
    SYNC:{
        name: 'SYNC',
        color: 'secondary',
        icon: undefined,
        text: 'Синхронизация успешна'
    },
    DONE: {
        name: 'DONE',
        color: 'secondary',
        icon: undefined,
        text: 'Синхронизация не требуется'
    }
}

export const order_statuses = {
    NEW: {
        name: 'NEW',
        color: 'error',
        text: ''
    },
    DELAYED:{
        name: 'DELAYED',
        color: 'orange',
        text: 'Отложить'
    },
    WAIT_CONFIRM: {
        name: 'WAIT_CONFIRM',
        color: 'purple',
        text: 'Подтвердить'
    },
    WAIT_PAY: {
        name: 'WAIT_PAY',
        color: 'orange',
        text: 'Оплатить'
    },
    COOKING:{
        name: 'COOKING',
        color: 'primary',
        text: 'Принять'
    },
    DELIVERING:{
        name: 'DELIVERING',
        color: 'blue',
        text: 'В пути'
    },
    ARCHIVED:{
        name: 'ARCHIVED',
        color: 'grey',
        text: 'В архив'
    },
    CANCELED:{
        name: 'CANCELED',
        color: 'grey darken-4',
        text: 'Удалить'
    },
}

export const objWithDefaultValue = (target, defaultValue) => {
    return new Proxy(target,{
        get: (obj, prop) => prop in obj ? obj[prop] : defaultValue
    })
}
export const SyncStatus = objWithDefaultValue(
    {
        ...sync_statuses  
    },
    sync_statuses.ERR
)
    
export const OrderStatus = objWithDefaultValue(
    {
        ...order_statuses
    },
    order_statuses.NEW
)
